import '../../entry.js';
import { popup, popupMutiErrorMsg } from '../jquery-components/popup.js';

const NO_UNION_MESSAGE = "費率設定有誤，請重新從首頁進入，若有問題請洽原業務員或客服團隊！";

$(function(){
    'use strict';
    if(!checkUnionInfo()){
        popup("提示",NO_UNION_MESSAGE,"確定");
    }

    $('.create-case-btn').on('click', function(){
        var $btn = $(this);
        if(!checkUnionInfo()){
            popup("提示",NO_UNION_MESSAGE,"確定");
        }else{
            $('#create-case-form').trigger("submit");
        }
    });

    $("#requestUri").val(location.pathname);
    $("#queryString").val(location.search);
});

function checkUnionInfo(){
    if($("meta[name='unionType']").attr("content")){
        return true;
    } else {
        return false;
    }
}